import Command from './Command';

export default class CompositeSequenceCommand extends Command {
  constructor(
    public id: number,
    public sceneId: number,
    public commands: Command[],
  ) {
    super(id, sceneId);
    commands.forEach((command, _idx) => {
      command.parent = this;
    });
  }
}
